import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

export default function Save() {
	const blockProps = useBlockProps.save( {
		className: 'brandy-sticky-section',
	} );

	return (
		<div { ...blockProps }>
			<div className="brandy-sticky-section__inner">
				<InnerBlocks.Content />
			</div>
		</div>
	);
}
